import { Component, Input, AfterViewInit, NgModule, NO_ERRORS_SCHEMA, OnChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import Boost from 'highcharts/modules/boost'
import noData from 'highcharts/modules/no-data-to-display'
import More from 'highcharts/highcharts-more'

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);

@Component({
    selector: 'app-pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.scss'],
    standalone: false
})
export class PieChartComponent implements AfterViewInit, OnChanges {

  @Input() config: any;
  @Input() data: any;

  ngAfterViewInit(): void {
    this.initPieChart();
  }

  ngOnChanges() {
    this.initPieChart();
  }

  initPieChart() {
    const options: any = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        height: this.config.height
      },
      title: {
        text: this.config.title
      },
      credits: {
        enabled: false
      },
      legend: this.config.legend,
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: this.config.dataLabels,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
          },
          showInLegend: true
        }
      },
      series: [{
        name: this.config.labelTooltips,
        colorByPoint: true,
        data: this.data
      }]
    }
    Highcharts.chart('container', options);
  }


}

@NgModule({
  imports: [],
  declarations: [PieChartComponent],
  exports: [PieChartComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class PieChartModule {

}

